import {
    GET_FOLDERS,
    SET_SEARCH_JOB_ID,
    SET_PAGE,
    SET_ROW,
    CREATE_FOLDER,
    GET_FILES,
    SET_FOLDER,
    UPLOAD_FILE,
    REMOVE_FILE,
    SET_SELECTED,
    MOVE_FILES,
    GET_POLICIES,
} from "./types";
import firebase from "firebase/app";
import { push } from "connected-react-router";
import moment from "moment";
let reference = "";

export const getPoliciesLength = () => {
    return (dispatch) => {
        dispatch({ type: GET_POLICIES.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(async (user) => {
                if (user) {
                    firebase
                        .database()
                        .ref("collections/company_policy")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_POLICIES.SUCCESS,
                                payload: snapshot.val(),
                            });
                            if (snapshot.val() === null) {
                                reference = 0;
                            } else {
                                reference = snapshot.val().length;
                            }
                        });
                } else {
                    dispatch({ type: GET_POLICIES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_FILES.FAIL });
        }
    };
};
export const getFiles = () => {
    return (dispatch) => {
        dispatch({ type: GET_FILES.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(async (user) => {
                if (user) {
                    //let files = await getAllFiles();
                    firebase
                        .database()
                        .ref(`/subjects/file_manager/`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_FILES.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_FILES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_FILES.FAIL });
        }
    };
};
export const getFolders = () => {
    return (dispatch) => {
        dispatch({ type: GET_FOLDERS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/folder_keys/`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_FOLDERS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_FOLDERS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_FOLDERS.FAIL });
        }
    };
};
export const setSearchVal = (val = "") => {
    return (dispatch) => {
        dispatch({ type: SET_SEARCH_JOB_ID, payload: val });
    };
};

export const setPage = (page = 0) => {
    return (dispatch) => {
        dispatch({ type: SET_PAGE, payload: page });
    };
};
export const setRows = (rows = 50) => {
    return (dispatch) => {
        dispatch({ type: SET_ROW, payload: rows });
    };
};
export const setFolder = (folder) => {
    return (dispatch) => {
        dispatch({ type: SET_FOLDER, payload: folder });
    };
};
export const setSelected = (item, list) => {
    return (dispatch) => {
        let newList = list.map((e) => {
            if (e.file_id === item.file_id) e.selected = item.selected;

            return e;
        });
        dispatch({ type: SET_SELECTED, payload: newList });
    };
};
export const redirectTo = (link) => {
    return (dispatch) => {
        dispatch(push(link));
    };
};

export const createFolder = (folder, callback) => {
    return (dispatch) => {
        dispatch({ type: CREATE_FOLDER.REQUEST });
        if (folder) {
            let key = folder.replace(/ /g, "_").toLowerCase();
            try {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/collections/folder_keys/${key}/`)
                            .set(folder)
                            .then(() => {
                                dispatch({
                                    type: CREATE_FOLDER.SUCCESS,
                                });
                                callback(true);
                            });
                    } else {
                        callback(true);
                        dispatch({ type: CREATE_FOLDER.FAIL });
                    }
                });
            } catch {
                callback(true);
                dispatch({ type: CREATE_FOLDER.FAIL });
            }
        } else {
            callback(true);
            dispatch({ type: CREATE_FOLDER.FAIL });
        }
    };
};
export const moveFiles = (folder = false, files = false, callback) => {
    let newFileID;
    return (dispatch) => {
        if (folder && files) {
            try {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        files.map(async (file, i) => {
                            dispatch({ type: MOVE_FILES.REQUEST });
                            if (file.selected)
                                var allFiles = await getAllFiles();

                            if (allFiles) {
                                //   let filesIDs = Object.keys(allFiles).map(fileID => fileID);
                                let IDs = Object.keys(allFiles).map((e) => {
                                    return Object.values(allFiles[e]).map(
                                        (f) => {
                                            return f.file_id;
                                        }
                                    );
                                });

                                let fileIDs = Math.max(...[].concat(...IDs));
                                newFileID = (Number(fileIDs) + 1)
                                    .toString()
                                    .padStart(6, "0");
                            } else if (allFiles === null) newFileID = "000001";
                            if (newFileID) {
                                await firebase
                                    .database()
                                    .ref(
                                        `/subjects/file_manager/${folder}/${newFileID}`
                                    )
                                    .update(file);
                                await firebase
                                    .database()
                                    .ref(
                                        `/subjects/file_manager/${folder}/${newFileID}`
                                    )
                                    .update({
                                        file_folder: folder,
                                        file_directory: folder,
                                        file_id: newFileID,
                                        selected: null,
                                        flag: null,
                                    });
                            }
                            if (file.selected) {
                                firebase
                                    .database()
                                    .ref(
                                        `/subjects/file_manager/${file.file_folder}/${file.file_id}`
                                    )
                                    .remove()
                                    .then(() => {
                                        dispatch({
                                            type: MOVE_FILES.SUCCESS,
                                        });
                                    });
                            }
                            return null;
                        });
                        callback(true);
                    } else {
                        callback(false);
                        dispatch({ type: MOVE_FILES.FAIL });
                    }
                });
            } catch {
                callback(false);
                dispatch({ type: MOVE_FILES.FAIL });
            }
        } else {
            callback(false);
            dispatch({ type: MOVE_FILES.FAIL });
        }
    };
};
export const removeFile = (files = false, callback) => {
    return (dispatch) => {
        dispatch({ type: REMOVE_FILE.REQUEST });
        if (files)
            try {
                firebase.auth().onAuthStateChanged(async (user) => {
                    if (user === null) {
                        dispatch({ type: REMOVE_FILE.FAIL });
                        callback(false);
                    } else {
                        let success = await removeFiles(files, dispatch);

                        callback(success);
                    }
                });
            } catch (e) {
                dispatch({ type: REMOVE_FILE.FAIL });
                callback(false);
            }
        else {
            dispatch({ type: REMOVE_FILE.FAIL });
            callback(false);
        }
    };
};
const removeFiles = async (files, dispatch) => {
    try {
        await files.map(async (file) => {
            if (file.selected)
                await firebase
                    .database()
                    .ref(`/subjects/file_manager/${file.file_directory}`)
                    .child(file.file_id)
                    .remove()
                    .then(() => {
                        dispatch({ type: REMOVE_FILE.SUCCESS });
                    });
        });
        return true;
    } catch {
        dispatch({ type: REMOVE_FILE.FAIL });
        return false;
    }
};
export const uploadFile = (folder, index, file, callback, duplicates) => {
    return async (dispatch) => {
        dispatch({ type: UPLOAD_FILE.REQUEST });

        let newFileID;
        let newName = false;
        if (duplicates[index]) newName = duplicates[index];
        let allFiles = await getAllFiles();
        let fileExists = await doesFileExist(file.name, folder);
        if (allFiles) {
            //   let filesIDs = Object.keys(allFiles).map(fileID => fileID);
            let IDs = Object.keys(allFiles).map((e) => {
                return Object.values(allFiles[e]).map((f) => {
                    return f.file_id;
                });
            });
            // filesIDs = filesIDs.sort().reverse();
            // //when testing multiple uploads on it's own it kept overriding the same 000XXX node, so I used index as a means of incrementing that so it would allows multples
            // newFileID = (Number(filesIDs[0]) + (Number(index) + 1))
            //     .toString()
            //     .padStart(6, "0");
            let fileIDs = Math.max(...[].concat(...IDs));
            newFileID = (Number(fileIDs) + 1 + Number(index))
                .toString()
                .padStart(6, "0");
        } else if (allFiles === null) newFileID = "000001";
        if (!fileExists) {
            let upload = firebase
                .storage()
                .ref(`files/${folder}`)
                .child(newName ? newName : file.name)
                .put(file);

            upload.on(
                "state_changed",
                (snapshot) => {
                    let progress =
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                    callback({
                        fileExists: false,
                        inProgress: true,
                        finished: false,
                        error: false,
                        progress: progress,
                        msg: "Upload is " + progress + "% done",
                    });
                },
                () => {
                    // Handle unsuccessful uploads
                    callback({
                        fileExists: false,
                        inProgress: false,
                        finished: false,
                        error: true,
                        msg: "Something went wrong with this upload!",
                    });
                    dispatch({ type: UPLOAD_FILE.FAIL });
                },
                () => {
                    upload.snapshot.ref.getDownloadURL().then((url) => {
                        let newFile = {
                            file_id: newFileID,
                            file_name: newName ? newName : file.name,
                            file_size: Number(file.size) || 0,
                            file_url: url,
                            date_added: new moment().format(
                                "DD-MM-YYYY hh:mm:ss"
                            ),
                            file_folder: folder,
                            file_type: file.type,
                            file_directory: folder,
                        };
                        if (folder === "company_policies") {
                            firebase
                                .database()
                                .ref(
                                    `/subjects/file_manager/${newFile.file_folder}/${newFileID}/`
                                )
                                .set(newFile)
                                .then(() => {
                                    firebase
                                        .database()
                                        .ref(
                                            `/collections/company_policy/${reference}/`
                                        )
                                        .update({
                                            file: newFile.file_name,
                                            fileURL: newFile.file_url,
                                        })
                                        .then(() => {
                                            dispatch({
                                                type: UPLOAD_FILE.SUCCESS,
                                            });
                                            callback({
                                                fileExists: false,
                                                inProgress: false,
                                                finished: true,
                                                error: false,
                                                msg: "Success",
                                            });
                                        });
                                });
                        } else {
                            firebase
                                .database()
                                .ref(
                                    `/subjects/file_manager/${newFile.file_folder}/${newFileID}/`
                                )
                                .set(newFile)
                                .then(() => {
                                    dispatch({
                                        type: UPLOAD_FILE.SUCCESS,
                                    });
                                    callback({
                                        fileExists: false,
                                        inProgress: false,
                                        finished: true,
                                        error: false,
                                        msg: "Success",
                                    });
                                });
                        }
                    });
                }
            );
        } else {
            dispatch({
                type: UPLOAD_FILE.FAIL,
            });
            callback({
                fileExists: true,
                inProgress: false,
                finished: false,
                error: false,
                msg: "Exists",
            });
        }
    };
};
export const doesFileExist = async (name, directory) => {
    let files = await getAllFiles();

    let flag = false;
    if (files) {
        Object.keys(files).map((index) => {
            if (
                files[index].file_name === name &&
                files[index].file_directory === directory
            )
                flag = true;
            return null;
        });
        return flag;
    } else if (files == null) {
        return false;
    }
};
export const getAllFiles = async () => {
    let files = await firebase
        .database()
        .ref(`subjects/file_manager`)
        .once("value");
    return files.val();
};
